import React from 'react';

const MealsSVG = ({ width, height }) => (
	<svg
		width={width || '40px'}
		height={height || '66px'}
		viewBox="0 0 40 66"
		xmlSpace="preserve"
		id="meals"
	>
		<title>4F66D981-19CC-4229-B7D1-27E1DF48B1C2@1x</title>
		<g
			id="NEW-2"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Park"
				transform="translate(-861.000000, -4183.000000)"
				stroke="#32C878"
				stroke-width="2.5"
			>
				<g id="Group-19" transform="translate(187.000000, 4183.000000)">
					<g id="Group-33" transform="translate(596.000000, 0.000000)">
						<g id="Group-6" transform="translate(80.000000, 0.000000)">
							<path
								d="M0.00327322432,0 L0.00327322432,21.5703387 C0.00327322432,24.7333064 2.56736516,27.2973984 5.73033287,27.2973984 L5.73033287,27.2973984 L5.73033287,27.2973984 L4.46933063,59.7375864 C4.37930456,62.0535716 6.183801,64.0040292 8.49978624,64.0940553 C8.55409615,64.0961664 8.60844194,64.0972222 8.66279286,64.0972222 C10.9715427,64.0972222 12.8431543,62.2256107 12.8431543,59.9168608 C12.8431543,59.8573124 12.8418819,59.7977709 12.839338,59.7382769 L11.452206,27.2973984 L11.452206,27.2973984 C14.6023526,27.2973984 17.156051,24.7437 17.156051,21.5935534 L17.156051,0 L17.156051,0"
								id="Path-24"
							></path>
							<line
								x1="5.41993989"
								y1="19.8611111"
								x2="5.41993989"
								y2="1.03028697e-13"
								id="Path-25"
							></line>
							<line
								x1="11.7393843"
								y1="19.8611111"
								x2="11.7393843"
								y2="1.03028697e-13"
								id="Path-25"
							></line>
							<path
								d="M36.1143843,60.4379403 L36.1143843,1.77517216 L36.1143843,1.77517216 C31.0319069,0.942347012 26.2366067,4.38737085 25.4037816,9.46984827 C25.3220962,9.96834894 25.281051,10.4726627 25.281051,10.9778116 L25.281051,34.9614901 C25.281051,38.3340042 27.4741536,41.3146692 30.693914,42.3181601 L30.693914,42.3181601 L30.693914,42.3181601 L29.1135307,60.4517587 C28.9526914,62.2972578 30.318378,63.9237164 32.1638771,64.0845558 C32.2607228,64.0929961 32.3578896,64.0972222 32.4551024,64.0972222 C34.476068,64.0972222 36.1143843,62.4589059 36.1143843,60.4379403 Z"
								id="Path-27"
							></path>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default MealsSVG;
